import { get, set, cloneDeep } from 'lodash'

export default {
  // Actualizamos el establecimiento completo
  setPlace: (state, value) => (state.data = { ...state.data, ...value }),
  // Actualizamos las configuraciones del establecimiento
  setPlaceConfigs: (state, value) => {
    value.forEach((addOn) => {
      const indexConfig = state.data.addOnConfigs.findIndex((config) => {
        return config.id === addOn.id
      })

      if (indexConfig > -1) {
        set(
          state.data,
          `addOnConfigs[${indexConfig}].configFields`,
          cloneDeep({
            ...get(state.data, `addOnConfigs[${indexConfig}].configFields`, {}),
            ...addOn.configFields
          })
        )
      }
    })
  },
  // Reseteamos los datos del establecimiento
  resetPlace: (state) => (state.data = null)
}
